import { Environment } from 'react-relay';

import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import { loginMutation } from '../authModal/authentication/login/loginMutation';
import {
    trackEmailLoginLinkComplete,
    trackVerificationFailedModalDisplayed,
} from '../authModal/authentication/authTracking';

const { EMAIL_LINK_LOGIN_RESEND_EMAIL_FLOW } = authModalLoader.constants;

export const loginUserWithEmailLoginToken = async (
    environment: Environment,
    emailLoginToken: string,
    refetchViewer: () => void
): Promise<void> => {
    try {
        await loginMutation(
            environment,
            {
                email: null,
                password: null,
                emailLoginToken,
            },
            {}
        );
        // TODO add tracking for stale user once labels are approved
        trackEmailLoginLinkComplete();
        refetchViewer();
    } catch (error) {
        const email = new URLSearchParams(window.location.search).get('email');
        // TODO add tracking for stale user once labels are approved
        trackVerificationFailedModalDisplayed();
        authModalLoader.show({
            action: authModalLoader.constants.REQUEST_PASSWORD_EMAIL,
            email,
            flow: EMAIL_LINK_LOGIN_RESEND_EMAIL_FLOW,
        });
    }
};
